import MUM from './MUM';

export default MUM;
